import React, { useContext, useState, useEffect } from 'react';
import { BsThreeDots } from "react-icons/bs";
import { observer } from "mobx-react-lite";
import { Context } from "../../..";
import { logout } from "../../../http/UserAPI";
import avatar from "../../../utils/Avatar.svg";
import menu from "../../../utils/menu.svg";

const CuratorChatHeader = observer(({ room, showSidebar , setShowSidebar , h }) => {
    const { user } = useContext(Context);
    const [menuVisible, setMenuVisible] = useState(false);
    const [contactName, setContactName] = useState("Не выбран");
    const [ava, setAva] = useState(avatar);
    const toggleMenu = () => {
        setMenuVisible(!menuVisible);
    };

    const handleLogout = async () => {
        try {
            await logout(); // Вызов функции logout
            console.log('User logged out successfully');
            user.setUser(null)
            user.setIsAuth(false)
        } catch (error) {
            console.error('Logout error', error);
        }
    };

    useEffect(() => {
        if (h) {
            setContactName(room?.courseID || "Не выбран");
            setAva(avatar)
        } else {
            setContactName(room?.members?.[0]?.first_name || "Не выбран");
            setAva(room?.members?.[0]?.avatar_url || avatar)
        }
    }, [h, room]);  // Запускать эффект при изменении room или h

    return (
        <div className="h-20 relative flex items-center justify-between p-4 border-b border-gray-200 bg-white">
            <div className="flex items-center">
                {!showSidebar &&
                    <button
                    className="mr-4 p-2"
                    onClick={() => setShowSidebar(!showSidebar)}
                >
                    <img src={menu} alt="menu"/>
                </button>
                }
                <img
                    src={ava}
                    alt="avatar"
                    className="w-10 h-10 rounded-full object-cover"
                />
                <div className="ml-4">
                    <h2 className="font-semibold text-gray-900">
                        {contactName}
                    </h2>
                </div>
            </div>
            <div className="relative">
                <button
                    className="p-2 hover:bg-gray-100 rounded-full z-50"
                    aria-label="More options"
                    onClick={toggleMenu}
                >
                    <BsThreeDots className="text-gray-600 text-xl" />
                </button>
                {menuVisible && (
                    <div
                        className="absolute right-0 mt-2 w-40 bg-white border border-gray-200 rounded shadow-md z-50"
                    >
                        <button
                            className="w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100"
                            onClick={handleLogout}
                        >
                            Выйти
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
});

export default CuratorChatHeader;